// extracted by mini-css-extract-plugin
module.exports = {"heroTextContainer":"PressCms_heroTextContainer__E99CU"};